// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1098":"e2d8646e","1242":"af223b2b","4967":"41940a67","5921":"d8540d64","8247":"302c49b8"}[chunkId] + ".css";
};